import { FieldValues, useController } from "react-hook-form";
import { TextInputWithLabel } from "../UI/TextInputWithLabel";
import { BaseFormFieldProps } from "./BaseFormFieldProps";

type Props<TFieldValues> = BaseFormFieldProps<
  TFieldValues,
  {
    label: string;
    msgInCaseOfError?: string;
  }
>;
export function FormTextField<TFieldValues extends FieldValues>({
  fieldName,
  control,
  label,
  required,
  msgInCaseOfError,
}: Props<TFieldValues>) {
  const {
    field: { onChange, value },
    fieldState: { invalid },
  } = useController({
    name: fieldName,
    control: control,
    rules: { required: required },
  });

  return (
    <TextInputWithLabel
      errorString={invalid ? msgInCaseOfError : undefined}
      label={label}
      value={value}
      onChange={onChange}
    />
  );
}
